import {
  Component,
  OnInit,
  HostListener,
  ElementRef,
  ViewChild,
  Sanitizer,
  SecurityContext,
  ChangeDetectionStrategy
} from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ConfigStateService, ApplicationConfigurationDto } from '@abp/ng.core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SupportComponent implements OnInit {
  @ViewChild('iframeCtrl') iframeCtrl: ElementRef;

  src: SafeResourceUrl;

  constructor(sanitizer: DomSanitizer, private drawerRef: NzDrawerRef<string>,private store: Store) {
    this.currentUser$ = this.store.select(state => state.ConfigState?.currentUser);
    this.src = sanitizer.bypassSecurityTrustResourceUrl(
      `//speehive.com/support?v=${new Date().getTime()}`
    );
  }

  currentUser$: Observable<ApplicationConfigurationDto['currentUser']>;
  currentUser: ApplicationConfigurationDto['currentUser'];

  loading = true;
  feedbNameTxtField: HTMLInputElement;
  feedbEmailTxtField: HTMLInputElement;

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.data === 'get_user') {
      const currentUserObj = {
        userName: this.currentUser.userName,
        email: this.currentUser.email,
      };
      const currentUserObjStr = JSON.stringify(currentUserObj);
      this.iframeCtrl.nativeElement.contentWindow.postMessage(currentUserObjStr, '*');
    }

    if (event.data === 'completed') {
      this.drawerRef.close();
    }

    this.loading = false;
  }

  ngOnInit(): void {
    this.currentUser$.subscribe(c => {
      this.currentUser = c;
    });
  }
}
